import { type FC } from 'react';
import DiceMask from '@assets/img/masks/dice-face.svg?react';
import cn from 'classnames';

import css from './styles.module.scss';

interface DiceFaceProps {
  className: string;
  dotQuantity: number;
  positionArray: string[];
}

const DiceFace: FC<DiceFaceProps> = ({
  className,
  dotQuantity,
  positionArray,
}) => {
  return (
    <div className={cn(css.face, className)}>
      {Array.from({ length: dotQuantity }).map((_, index) => (
        <span
          key={index}
          style={{ gridArea: positionArray[index], zIndex: 1 }}
          className={css.dot}
        ></span>
      ))}
      <DiceMask className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[4.25rem] h-[4.25rem]" />
    </div>
  );
};

export { DiceFace };
